import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import AppointmentCardActions from '../AppointmentCardActions/AppointmentCardActions'
import styles from './AppointmentCardSmall.module.sass'
import stylesActions from '../AppointmentCardActions/AppointmentCardActions.module.sass'
import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'
import AppointmentRequisitions from '../AppointmentRequisitions/AppointmentRequisitions'
import AppointmentDocuments from '../AppointmentDocuments/AppointmentDocuments'
import AppointmentHistory from '../AppointmentHistory/AppointmentHistory'
import getMedicalSpecialtyClass from 'utils/getMedicalSpecialty'

const AppointmentCardSmall = (props) => {
	const {
		mappedDocuments,
		hasRequisitions,
		expanded,
		data,
		showHistory,
		setExpanded,
		setShowHistory,
		...attributes
	} = props

	let lengthStyleAlerts = ''
	if (
		(!hasRequisitions && data.hasDocuments) ||
		(hasRequisitions && !data.hasDocuments)
	) {
		lengthStyleAlerts = styles['--alerts-short']
	}

	return (
		<div {...attributes} className={`${styles['root'] || ''}`}>
			<VStack {...attributes}>
				<HStack
					className={`${styles['appointment-card']} ${
						expanded && styles['--expanded']
					}`}
				>
					<div
						className={`${styles['appointment-specialty']} ${
							styles[
								`--${getMedicalSpecialtyClass(
									data?.medicalSpecialty?.id
								)}-color`
							]
						}`}
					/>
					{!expanded && (hasRequisitions || data.hasDocuments) ? (
						<div
							className={`${styles['appointment-alerts']} ${lengthStyleAlerts}`}
						>
							{hasRequisitions && (
								<Icon
									name='requisition'
									width='20px'
									height='20px'
								/>
							)}
							{data.hasDocuments && (
								<Icon name='clip' width='20px' height='20px' />
							)}
						</div>
					) : (
						''
					)}
					<VStack
						className={`${styles['card-content-details']} ${
							expanded && styles['--expanded']
						}`}
					>
						<div
							className={`${styles['content-header']} ${
								expanded &&
								((showHistory &&
									data?.history &&
									data?.history?.length > 0) ||
									data?.hasDocuments ||
									(data?.requisitions &&
										data?.requisitions.length > 0))
									? styles['--expanded']
									: ''
							}`}
						>
							<VStack
								className={
									styles['appointment-specialty-doctor']
								}
							>
								<h5>{data?.medicalSpecialty?.name}</h5>
								<small>{data?.doctor?.name}</small>
							</VStack>
							{expanded && data?.previousAppointment ? (
								<HStack
									className={styles['previous-appointment']}
								>
									<Icon
										className={
											styles['subdirectory-arrow-icon']
										}
										name='subdirectory-arrow'
										width='20px'
										height='20px'
									></Icon>
									<VStack>
										<small>
											{
												data?.previousAppointment
													?.specialty
											}
										</small>
										<small>
											#{data?.previousAppointment?.id}
										</small>
									</VStack>
								</HStack>
							) : (
								''
							)}
							<HStack className={styles['content-date']}>
								<h5>{data?.date?.shortDateFormat}</h5>
								<small>{data?.date?.shortTimeFormat}</small>
							</HStack>
							<VStack>
								<SlidingText
									className={styles['content-location']}
								>
									<strong>{data?.establishment?.name}</strong>
								</SlidingText>
								<SlidingText>
									<small>{data?.transport}</small>
								</SlidingText>
							</VStack>
						</div>
					</VStack>
					<AppointmentCardActions
						data={data}
						setExpanded={setExpanded}
						showHistory={showHistory}
						setShowHistory={setShowHistory}
					/>
				</HStack>
				<VStack className={styles['card-observation-section']}>
					<VStack
						className={`${styles['observation']} ${
							expanded &&
							((showHistory &&
								data?.history &&
								data?.history?.length > 0) ||
								data?.hasDocuments ||
								(data?.requisitions &&
									data?.requisitions.length > 0))
								? styles['--expanded']
								: ''
						}`}
					>
						<div className={styles['card-observation-container']}>
							<p
								className={`${styles['card-observation']} ${
									expanded && styles['--expanded']
								} `}
							>
								{data?.medicalObservation
									? data?.medicalObservation
									: null}
							</p>
						</div>
						{data?.disability?.id ? (
							<div className={styles['ita']}>
								<h5>{data?.disability?.id}</h5>
								<small>
									{data?.disability?.disabilityPercentage}
								</small>
							</div>
						) : null}
					</VStack>
					{expanded && (
						<>
							{data?.requisitions.length ? (
								<AppointmentRequisitions data={data} />
							) : (
								''
							)}
							{data?.hasDocuments ? (
								<AppointmentDocuments data={data} />
							) : (
								''
							)}
							{showHistory && data?.history ? (
								<AppointmentHistory data={data} />
							) : (
								''
							)}
						</>
					)}
					<HStack className={styles['content-observation-footer']}>
						<button
							className={styles['read-more']}
							onClick={() => setExpanded(!expanded)}
						>
							{expanded ? (
								<h5>{data.$cardLabels?.seeLess}</h5>
							) : (
								<h5>{data.$cardLabels?.seeMore}</h5>
							)}
						</button>
						<div className={stylesActions['card-id-status']}>
							<h5
								className={
									stylesActions[
										`card-id-status-${data?.status?.icon}`
									]
								}
							>
								{data?.status?.description}
							</h5>
							<small>#{data?.id}</small>
						</div>
					</HStack>
				</VStack>
			</VStack>
		</div>
	)
}

export default AppointmentCardSmall
